import {baseDataAddedServiceList} from "@/components/QuotationManagement/components-productQuotation/productQuotation";

/**
 * 增值服务：将编辑的 addedServiceList[] 处理返回 提交需要的 quoteAttachPrice{} 数据结构
 * @param target {Array}  编辑的 addedServiceList[] 数据结构 （默认为 this.editFormData.addedServiceList）
 * @returns {{declarationDTO: *[], lightDTO: *[], detailDTO: *[], chargeDTO: *[]}}
 */
export function disposeFormAddedServiceListToQuoteAttachPrice(target = []){
  let obj = {
    chargeDTO:[],//超重费、大型包裹费
    declarationDTO:[],//一般贸易报关费
    detailDTO:[],//一般增值服务
    lightDTO:[],//超轻费
  };
  if(Array.isArray(target)) target.forEach(res=>{
    if(res.isPremium !== 1) return false;
    let item = Object.assign({},res);
    delete item.isPremium;
    delete item.useDefaultTemplate;
    delete item.propKey;
    delete item.rulesKey;
    delete item.priceUnitText;
    if([18998741400,18998744000].includes(item.feeitemid)){
      obj.chargeDTO.push(item);
    }
    else if([18998741800].includes(item.feeitemid)){
      obj.declarationDTO.push(item);
    }
    else if([18998741700].includes(item.feeitemid)){
      obj.lightDTO.push(item);
    }else{
      obj.detailDTO.push(item);
    }
  });
  return obj;
}


export let mixinsAddedService = {
  data() {
    return {
      /* 选择框 数据 */
      isPremiumList:[
        {name:'加收',id:1},
        {name:'不加收',id:2},
      ],
      priceUnitList:[{namec:'CBM',id:0},{namec:'KG',id:1},],
    }
  },
  methods:{
    /**
     *  将获取的 产品报价详情中的 quoteAttachPrice{} 处理返回可编辑的 addedServiceList[] 数据结构
     * @param target
     * @returns {*}
     */
    disposeFormQuoteAttachPriceToAddedServiceList(target = this.editFormData.quoteAttachPrice){
      let list = baseDataAddedServiceList();
      if(typeof target !== 'object' || target === null) return list;
      let defaultList = [].concat(target.chargeDTO,target.declarationDTO,target.detailDTO,target.lightDTO);
      defaultList.forEach(res=>{
        if(!res) return false;
        // res.feeitemid = res.feeitemid ? res.feeitemid.toString() : '';
        let item = list.find(item=>item.feeitemid === res.feeitemid);
        if(item){
          Object.assign(item,res,{name:item.name,code:item.code,});
        }
      });
      list.forEach(res=>{
        if(res.price) res.isPremium =1;
      });
      return list;
    },
    /**
     * 将编辑的 addedServiceList[] 处理返回 提交需要的 quoteAttachPrice{} 数据结构
     */
    disposeFormAddedServiceListToQuoteAttachPrice:function (target = this.editFormData.addedServiceList) {
      return disposeFormAddedServiceListToQuoteAttachPrice(target)
    },
  },
  computed:{
  }
};



// WEBPACK FOOTER //
// ./src/components/QuotationManagement/components-productQuotation/addedServiceSetting.js